<template>
  <!-- 活动配置 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="配置" width="600px" center=""
      @close="closeDialog">
      <el-form :model="dataForm" ref="dataForm" size="small" :rules="replyRules">
        <el-form-item>
          <el-switch v-model="dataForm.switch_status" :active-value="1" :inactive-value="0" active-text="开启"
            inactive-text="关闭"></el-switch>
        </el-form-item>
        <el-form-item label="开启时间段：">
          <el-date-picker style="width: 200px" v-model="dataForm.start_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
          ——
          <el-date-picker style="width: 200px" v-model="dataForm.end_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="页面消失时间">
          <el-date-picker style="width: 200px" v-model="dataForm.display_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="本期活动id：">
          <el-input style="width: 200px; margin-right: 20px" placeholder="请输入本期活动id" v-model="dataForm.act_type">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="热血盲盒消耗战力">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入消耗战力"
            v-model="dataForm.battle_consumption"
          ></el-input>
        </el-form-item>
        <el-form-item label="普通盲盒消耗战力">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入消耗战力"
            v-model="dataForm.box_consumption"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '@/components/goods/AddGoods.vue'
import AddDebris from '@/components/debrisActivity/AddDebris.vue'

export default {
  components: {
    AddGoods,
    AddDebris
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        switch_status: 0,
        start_time: '',
        end_time: '',
        display_time: '',//前端页面消失时间
        act_type: '',//本地活动id
        battle_consumption: '',//盲盒消耗战力
        box_consumption: '',//开箱消耗战力
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      getApiData('turntable_enable').then((res) => {
        this.dataForm = res
      })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      this.dataForm.act_type=Number(this.dataForm.act_type)
      let params = this.dataForm
      patchApiData('turntable_enable', params).then(res => {
        this.$message.success("操作成功")
        // this.$emit('refresh')
        this.closeDialog()
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }
}

</script>
<style lang="less" scoped>

</style>